import React from 'react';

interface ToggleProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label: string;
  className?: string;
}

/** An on/off switch with its label; the whole label toggles it. */
const Toggle: React.FC<ToggleProps> = ({ checked, onChange, label, className = '' }) => (
  <label className={`flex cursor-pointer items-center gap-2 text-sm text-neutral ${className}`}>
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      onClick={() => onChange(!checked)}
      className={`relative inline-flex h-5 w-9 shrink-0 rounded-full border-2 border-transparent transition-colors ${
        checked ? 'bg-[#8B5CF6]' : 'bg-white/10'
      }`}
    >
      <span
        aria-hidden="true"
        className={`inline-block h-4 w-4 transform rounded-full bg-white shadow transition ${
          checked ? 'translate-x-4' : 'translate-x-0'
        }`}
      />
    </button>
    {label}
  </label>
);

export default Toggle;
